import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SUPER_ADMIN_PAGE_DESCRIPTIONS } from '@/config/superAdminDescriptions';

interface SuperAdminPageHelpProps {
  /** Chemin à utiliser (défaut: pathname actuel) */
  path?: string;
}

export function SuperAdminPageHelp({ path: pathProp }: SuperAdminPageHelpProps) {
  const { pathname } = useLocation();
  const path = pathProp ?? pathname;
  const description = SUPER_ADMIN_PAGE_DESCRIPTIONS[path];
  const [isOpen, setIsOpen] = useState(false);

  if (!description) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="p-1.5 rounded-full text-slate-500 hover:text-primary dark:text-slate-400 dark:hover:text-accent hover:bg-slate-100 dark:hover:bg-gray-800 transition-colors"
        aria-label="Aide sur cette page"
        title="Aide"
      >
        <span className="material-icons-outlined text-lg">help</span>
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
          onClick={() => setIsOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="super-admin-help-title"
        >
          <div
            className="bg-white dark:bg-[#16202A] rounded-xl shadow-xl max-w-lg w-full p-6 border border-slate-200 dark:border-[#1E293B]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4 mb-4">
              <h2
                id="super-admin-help-title"
                className="text-lg font-semibold text-slate-900 dark:text-white flex items-center gap-2"
              >
                <span className="material-icons-outlined text-primary dark:text-accent">info</span>
                À propos de cette page
              </h2>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="p-1 rounded-md text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-gray-800 transition-colors"
                aria-label="Fermer"
              >
                <span className="material-icons-outlined">close</span>
              </button>
            </div>
            <p className="text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
              {description}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
